import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import {Link} from "react-router-dom";
import {styled} from '@mui/material/styles';
import {selToken, selUser} from "../../../stores/base/baseSlice";
import {tagValidations, FormTagInit} from "../../../stores/tag/model";
import {createTag, editTag, getTagById} from "../../../stores/tag/thunk";
import {initTagForm, onTagFormChange, selTagForm} from "../../../stores/tag/slice";
import {notification} from "../../functions/notification/notificationFunction";


const Input = styled('input')({
    display: 'none',
});

export default function Tag() {

    const tag = useSelector(selTagForm);
    const user = useSelector(selUser);
    const token = useSelector(selToken);
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: tagValidations,
        key: 'tagForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onTagFormChange({name, value}))
    }

    function backToTags() {
        history.push('/tags');
    }

    const redirectToBlogs =()=> history.push("/tags")

    async function addTag(){
        const data = { name : tag.name}
        const check = await checkValidation(data)
        if (!check) return dispatch(notification("error", "", <h3>فیلد نام الزامی است</h3>, false))
        dispatch(createTag(data, redirectToBlogs))
    }


    async function putTag(){
        const data = { name : tag.name}
        const check = await checkValidation(data)
        if (!check) return dispatch(notification("error", "", <h3>فیلد نام الزامی است</h3>, false))
        dispatch(editTag(id, data, redirectToBlogs))
    }



    useEffect(() => {
        id ?
            dispatch(getTagById(id))
            :
            dispatch(initTagForm(FormTagInit))
        return ()=>{
            dispatch(initTagForm(FormTagInit))
        }
    }, [id])


    return (
        <Grid item xs={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن برچسب"
                backBtnTitle="بازگشت"
                backBtnAction={backToTags}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان برچسب'}
                                        variant="outlined"
                                        name={'name'}
                                        value={tag?.name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putTag : addTag }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            { id ? 'ویرایش' : 'ایجاد' }
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
